'use strict';

export default class SearchRouteTime extends React.Component {
    componentDidMount() {
        const {index, onSelect} = this.props;
        const that = this;
        this.el = $(`.routeTime${index}`);
        this.el.select2({
            minimumResultsForSearch: -1,
            allowClear: true,
        })
        this.el.on('select2:open', function (e) {
            $('body').find('.select2-dropdown').addClass('time-drop');
        });
        this.el.on('select2:unselect', function (e) {
            onSelect('')
            setTimeout(() => that.el.select2('close'))
        })
        this.el.on('select2:select', function (e) {
            onSelect(e.params.data.id.trim())
        })
    }

    shouldComponentUpdate(nextProps) {
        if(this.props.value !== nextProps.value) {
            this.el.val(nextProps.value).trigger('change');
            return true;
        }
        if(this.props.error !== nextProps.error) return true;
        return false;
    }

    getList() {
        let list = [];
        for(let i = 0; i < 24; i++) {
            const h = i < 10 ? `0${i}` : i;
            list.push(`${h}:00`);
            list.push(`${h}:30`);
        }
        return list;
    }

    render() {
        const {index, value, error, hidden} = this.props;

        if (hidden)
            return <input type='hidden' value={value}/>

        return <div className={clsx('search-inputbox search-time', {error})}>
            <select className={clsx(`routeTime${index}`)} data-placeholder={tMsg('Время')} defaultValue={value}>
                <option value=""></option>
                {this.getList().map((time, index) => {
                    const key = `searchRouteTimeItem${index}`;
                    return <option key={key} value={time}>{time}</option>
                })}
            </select>
        </div>
    }
}
